import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import { UploadIconButton } from '../IconButton';
import { UploadFileExtension } from 'packages/manualDataTapeUploads/ui/UploadDataTapeDropzone';
import { UploadDataTapeForm } from 'packages/manualDataTapeUploads/ui/UploadDataTapeForm';

type FileUploadButtonProps = {
  allowedExtensions: UploadFileExtension[];
  buttonText: string;
  modalHeaderText?: string;
  handleFile: (file: File) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  children: React.ReactNode;
};
export const FileUploadButton = ({
  buttonText,
  modalHeaderText,
  handleFile,
  allowedExtensions,
}: FileUploadButtonProps) => {
  const [loanTapeUploadLoading, setLoanTapeUploadLoading] = useState(false);
  const [isUploadLoanTapeModalOpen, setIsUploadLoanTapeModalOpen] = useState(
    false,
  );
  const onLoanTapeModalClose = () => setIsUploadLoanTapeModalOpen(false);

  return (
    <>
      <UploadIconButton
        isLoading={loanTapeUploadLoading}
        onClick={() => setIsUploadLoanTapeModalOpen(true)}
        ariaLabel={buttonText}
        label={buttonText}
      >
        Export
      </UploadIconButton>
      <Modal
        isOpen={isUploadLoanTapeModalOpen}
        onClose={onLoanTapeModalClose}
        size="lg"
      >
        <ModalOverlay />
        <ModalContent padding="20px" width="auto" minW="550px">
          <ModalHeader>{modalHeaderText ?? 'Upload Tape'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <UploadDataTapeForm
              allowedExtensions={allowedExtensions}
              onClose={onLoanTapeModalClose}
              handleFile={async (file: File) => {
                try {
                  setLoanTapeUploadLoading(true);
                  await handleFile(file);
                } finally {
                  setLoanTapeUploadLoading(false);
                }
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
